export const dummyPosts = [
	{ title: "", body: "", id: "1", date: "" },
	{ title: "", body: "", id: "2", date: "" },
	{ title: "", body: "", id: "3", date: "" },
	{ title: "", body: "", id: "4", date: "" },
	{ title: "", body: "", id: "5", date: "" },
]